// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://htldhcfyytxidsnckhya.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh0bGRoY2Z5eXR4aWRzbmNraHlhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAwMjEwOTMsImV4cCI6MjA2NTU5NzA5M30.CntmoXW8yzVlXRN_Trbnm2wgpBxjvLJEeaKnVypb1JE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);